import * as React from "react";
import type { SVGProps } from "react";
const SvgCustomer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <g clipPath="url(#customer_svg__a)">
      <path
        fill="#23F6E7"
        fillRule="evenodd"
        d="M11.75 10.5a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5M21.5 18c0-3.55-5.263-6.428-9.75-6.428S2 14.45 2 18v4a2 2 0 0 0 2 2h15.5a2 2 0 0 0 2-2z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="customer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCustomer;
